// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__wvH1w","rootCenter":"LoadMoreObserver_rootCenter__2Lwik","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1zS2Y"};